import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="gtm"
export default class extends Controller {
  connect() {
    document.addEventListener("turbo:load", () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "page_view",
        page_location: window.location.href,
        page_path: window.location.pathname,
        page_title: document.title
      });
    });
  }
}
